import React, { PureComponent } from "react";
import { withApollo } from "react-apollo";
import { withStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import AppQraphQL from "js/graphql/resolvers/proveedor.resolver";

import { styles } from "js/components/Shared/Form/styles.js";
import { ListofChildrenField } from "./index.js";

class Proveedor extends PureComponent {
  state = { proveedores: [] };

  async componentDidMount() {
    const { client } = this.props;
    await client
      .query({
        query: AppQraphQL.queries.getProveedores,
        fetchPolicy: "network-only",
        errorPolicy: "all"
      })
      .then(res => {
        this.setState({ proveedores: res.data.getProveedores.itemsPagina });
      });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.idProveedor !== this.props.idProveedor ||
      prevState.proveedores !== this.state.proveedores
    ) {
      const { idProveedor, onChangeProveedor } = this.props;
      const p = this.state.proveedores.find(
        p => !!p.tieneSucursales && p.idProveedor === idProveedor
      );
      onChangeProveedor(!!p);
    }
  }

  render() {
    const { classes, disabled, required } = this.props;
    const { proveedores } = this.state;

    return (
      <ListofChildrenField
        name="idProveedor"
        label="Proveedor"
        classes={classes ? classes.field : styles.field}
        disabled={disabled}
        required={required}
      >
        {proveedores.map((proveedor, index) => (
          <MenuItem key={index} value={proveedor.idProveedor}>
            {proveedor.nombreFantasia}
          </MenuItem>
        ))}
      </ListofChildrenField>
    );
  }
}

export default withStyles(styles)(withApollo(Proveedor));
